export const DIALOG_ADD = "DIALOG_ADD";
export const DIALOG_ADD_SUCCESS = "DIALOG_ADD_SUCCESS";
export const DIALOG_ADD_ERROR = "DIALOG_ADD_ERROR";

export const DIALOG_DELETE = "DIALOG_DELETE";
export const DIALOG_DELETE_SUCCESS = "DIALOG_DELETE_SUCCESS";
export const DIALOG_DELETE_ERROR = "DIALOG_DELETE_ERROR";

export const DIALOG_GET_LIST = "DIALOG_GET_LIST";
export const DIALOG_GET_LIST_SUCCESS = "DIALOG_GET_LIST_SUCCESS";
export const DIALOG_GET_LIST_ERROR = "DIALOG_GET_LIST_ERROR";

export const MESSAGE_ADD = "MESSAGE_ADD";
export const MESSAGE_ADD_SUCCESS = "MESSAGE_ADD_SUCCESS";
export const MESSAGE_ADD_ERROR = "MESSAGE_ADD_ERROR";

export const MESSAGE_GET_HISTORY = "MESSAGE_GET_HISTORY";
export const MESSAGE_GET_HISTORY_SUCCESS = "MESSAGE_GET_HISTORY_SUCCESS";
export const MESSAGE_GET_HISTORY_ERROR = "MESSAGE_GET_HISTORY_ERROR";
